import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SaveDialogService {
  active = false;
  active$ = new EventEmitter();

  zIndex = 0;

  constructor() {}

  show() {
    this.active = true;
    this.active$.emit(true);
  }

  hide() {
    this.active = false;
    this.active$.emit(false);
  }
}
